import { render, staticRenderFns } from "./MenuNotifications.vue?vue&type=template&id=4b26482d&scoped=true&"
import script from "./MenuNotifications.vue?vue&type=script&lang=js&"
export * from "./MenuNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MenuNotifications.vue?vue&type=style&index=0&id=4b26482d&prod&lang=sass&scoped=true&"
import style1 from "./MenuNotifications.vue?vue&type=style&index=1&id=4b26482d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b26482d",
  null
  
)

export default component.exports